import axios from 'axios'

export const postNPS = (data) => {
  return axios.post('/nps', data)
}

export const ignoreNPS = () => {
  return axios.put('/nps/ignore')
}
